module.exports = __webpack_public_path__ + "static/media/2.14f0f3ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/phonics-detail/2.png
// module id = 571
// module chunks = 0